import React from 'react'
import DynamicBreadcrumb from '../../../components/DynamicBreadcrumb'
import TechnologyHead from '../techComponent/TechnologyHead'
import TechnologyNex from '../techComponent/TechnologyNex';

const breadcrumbData = [
  {
    page: "Home",
    slug: "/",
  },
  {
    page: "Technologies",
    slug: "",
  },
  {
    page: "Cloud Computing",
    slug: "",
  }
]

const techData ={
  label: "Technologies",
  heading: "cloud computing solutions: secure, scalable & on-demand document storage for seamless access anytime, anywhere",
  img: "/assets/images/teach-cloud.webp",
  alt: "teach-cloud",
  description: `
    <p>Cloud computing as technology means using internet servers for storage, management, processing of records for the entire life cycle. Records and data management through the use of this technology has its own set of risks and benefits. Cost-effective, increase in efficiency, better accessibility, flexibility as benefits need to be weighed against the risks of security, privacy, information management. For complete understanding of the cloud computing working model, we can divide it into two parts - frontend and backend.</p>

    <p>To understand how cloud computing works, it can be divided into front-end and backend. The front end of the server is used to access user data in the cloud with the help of an internet browser or any regular cloud computing software anytime. The backend of the cloud computing technology is responsible for scalable & on-demand secure data and information storage. It consists of servers, computers, databases, and central servers.</p>

    <p>Central servers manage the operations by following some defined protocols. It uses software middleware to ensure seamless connectivity between all the devices linked via cloud computing. Records Management organizations providing their clients with cloud computing usually maintain multiple data copies to eliminate any risks of security threats, data loss, data breach, etc. There are 3 types of cloud computing models as explained below.</p>

    <h2>Smart Solutions</h2>
    <p>IoT-enabled systems deliver secure, automated, real-time document management for complete visibility and control. They ensure accurate tracking, streamlined workflows, reduced operational risks across all records. This enhances efficiency, improves access, supports faster, more reliable decision-making. It also enables better compliance and consistent operational performance.</p>

    <ul>
      <li><b>IaaS (Infrastructure as Service):</b> Most common cloud computing service model, ideal for small and medium-sized organizations. It provides the fundamental infrastructure of virtual servers, networks, operating systems, data storage drives. It makes enough room for flexibility, reliability, scalability which many businesses seek with cloud computing and eliminates the use of hardware.</li>

      <li><b>PaaS (Platform-as-a-Service):</b> Cloud Computing providers in this model, provide the required infrastructure and software framework, businesses can develop and run their applications. PaaS allows web applications to be created quickly and the service is flexible and robust to support them.</li>

      <li><b>SaaS (Software as a Service):</b> This cloud computing service model allows software deployment for various businesses over software and usage on the pay-per-use model. SaaS is managed from a central location so businesses don’t have to worry about maintaining it themselves, are ideal for short-term projects.</li>
    </ul>

    <p>Certain pointers to be kept in mind while using the cloud computing service models are:</p>

    <ul>
      <li><b>Creation:</b> Digital records need to be created and managed to ensure the authenticity and reliability of digitized records.</li>

      <li><b>Distribution:</b> Records created from the client's end can be easily transmitted to cloud servers securely, reliability while preserving integrity.</li>

      <li><b>Preservation:</b> Records stored regularly should be done safely and reliably and be always traceable for long term benefits.</li>

      <li><b>Migration:</b>  Records being migrated from one cloud storage to another, should not go missing due to the difference in the cloud architecture. Redundant records in cloud storage should be securely destroyed and disposed of.</li>

      <li><b>Backup:</b>  Cloud service providers should provide detailed backup methods for long term archives.</li>
    </ul>

    <p>Based on specific requirements, organizations can choose how, where, when to use cloud computing service for an efficient and reliable IT solution.</p>
  `
};

const techNextData = [
  {
    img: "assets/images/iot-img.webp",
    title: "IOT Enabled System",
    slug:"/iot-enabled"
  },
  {
    img: "/assets/images/iot-img2.webp",
    title: "Artificial Intelligence",
    slug:"/artificial-intelligence"
  },
];

export default function CloudComputing() {
  return (
    <>
      <DynamicBreadcrumb breadcrumbData={breadcrumbData} />
      <TechnologyHead data={techData}/>
      <TechnologyNex technex = {techNextData} />
    </>
  )
}
